import {formatNextPageUrl} from '../assets/blog';
import {formatUrl} from '@teemill/common';
import Blog from '../classes/blog';

export default {
  /**
   * ? ||
   *
   * ? Display actions for viewing blogs on frontends
   *
   * ? ||
   */
  /**
   * Fetch a list of paginated blogs from the server
   *
   * @param {Store}  store Blog vuex store module
   * @param {String} url   Url to send request to
   */
  fetchPaginatedPosts({state, commit}, {divisions}) {
    return new Promise((resolve, reject) => {
      if (state.fetching === true) {
        resolve([]);
      }
      commit('setVariable', {
        key: 'fetching',
        value: true,
      });

      $axios
        .get(formatUrl(state.next), {
          params: {
            divisions,
            paginate: state.paginate,
          },
        })
        .then(({data}) => {
          commit('appendPosts', Blog.map(data.data));
          commit('setVariable', {
            key: 'total',
            value: data.total,
          });
          commit('setVariable', {
            key: 'next',
            value: formatNextPageUrl(data.next_page_url),
          });
          resolve(data);
        })
        .catch(response => reject(response))
        .finally(() => {
          commit('setVariable', {
            key: 'fetching',
            value: false,
          });
        });
    });
  },
  /**
   * Fetch a list of posts with a certain tag
   *
   * @param {Store}  store    Blog vuex store module
   * @param {String} url      url to fetch post at
   */
  async findPost(store, {divisions, post}) {
    return new Promise((resolve, reject) => {
      $axios
        .get(formatUrl('/omnis/v3/blog/find/'), {
          params: {
            blogPost: post,
            divisions,
          },
        })
        .then(({data}) => {
          resolve(Blog.map(data));
        })
        .catch(response => reject(response));
    });
  },
  /**
   * Fetch all posts for specified divisions
   *
   * @param { Store } store
   * @param { Object } divisions
   */
  fetchAllPosts({commit}, {divisions}) {
    return new Promise((resolve, reject) => {
      $axios
        .get(formatUrl('/omnis/v3/blog/list/'), {
          params: {
            divisions,
            lite: true,
          },
        })
        .then(({data}) => {
          commit('setVariable', {
            key: 'posts',
            value: Blog.map(data),
          });
          commit('setVariable', {
            key: 'next',
            value: null,
          });
          resolve(data);
        })
        .catch(({response}) => reject(response));
    });
  },
  /**
   * Fetch a list of posts with a certain tag
   *
   * @param {Store} store
   * @param {String} url
   */
  fetchTaggedPosts({commit, getters}, {tag, divisions}) {
    return new Promise((resolve, reject) => {
      $axios
        .get(formatUrl('/omnis/v3/blog/tag/'), {
          params: {
            blogTag: tag,
            divisions,
          },
        })
        .then(({data}) => {
          data.posts = Blog.map(data.posts);
          commit('setVariable', {
            key: 'tag',
            value: data,
          });
          commit('pushVariables', {
            key: 'tagsPosts',
            value: data,
          });
          /**
           * If the fetched tag does not exist in our current state tag list,
           * add it to the tags so we dont have to fetch it again
           */
          if (!getters.tagsPosts(data.code)) {
            commit('pushVariables', {
              key: 'tags',
              value: data,
            });
          }
          resolve(data);
        })
        .catch(({response}) => reject(response));
    });
  },
  /**
   * Fetch a list of posts with a certain tag
   *
   * @param {Store}  store Blog vuex store module
   * @param {String} url   Url to send request to
   */
  fetchTags({commit}, {divisions}) {
    return new Promise((resolve, reject) => {
      $axios
        .get(formatUrl('/omnis/v3/blog/tags/published/'), {
          params: {
            divisions,
          },
        })
        .then(({data}) => {
          commit('setVariable', {
            key: 'tags',
            value: data,
          });
          resolve(data);
        })
        .catch(({response}) => reject(response));
    });
  },
  /**
   * Fetch a list of posts with a certain tag
   *
   * @param {Store}  store Blog vuex store module
   * @param {String} url   Url to send request to
   */
  fetchTagsPosts({commit}, {divisions}) {
    return new Promise((resolve, reject) => {
      $axios
        .get(formatUrl('/omnis/v3/blog/tags-posts/'), {
          params: {
            divisions,
          },
        })
        .then(({data}) => {
          commit('setVariable', {
            key: 'tagsPosts',
            value: Blog.map(data),
          });
          resolve(data);
        })
        .catch(({response}) => reject(response));
    });
  },
  /**
   * Logs the blog post as viewed by the currently logged in user / customer.
   *
   * @param {Store} store
   * @param {Post} id
   */
  logPostView(store, {id}) {
    return $axios.post(formatUrl('/omnis/v3/blog/log/viewed/'), {
      blogPostId: id,
    });
  },
  /**
   * Logs the blog post as read by the currently logged in user / customer.
   *
   * @param {Store} store
   * @param {Post} id
   */
  logPostRead(store, {id}) {
    return $axios.post(formatUrl('/omnis/v3/blog/log/read/'), {
      blogPostId: id,
    });
  },
  /**
   * ? ||
   *
   * ? Blog editor actions to create, update, delete posts
   *
   * ? ||
   */
  /**
   * Fetch all posts for the passed divisions
   *
   * @param { Store } store     The vuex store
   * @param { Array } divisions An array of divisions to get posts for
   */
  fetchBlogPosts({commit}, {divisions}) {
    return new Promise((resolve, reject) => {
      $axios
        .get(formatUrl('/omnis/v3/blog/list/'), {
          params: {
            divisions,
          },
        })
        .then(({data}) => {
          commit('fetchBlogPosts', data);
          resolve(data);
        })
        .catch(({response}) => reject(response));
    });
  },
};
